<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit(null)">
          新增
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.position"
              clearable
              placeholder="位置"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="类型" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag v-if="row.typehood === 2">H5</el-tag>
          <el-tag v-else type="success">小程序</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="图片" show-overflow-tooltip>
        <template #default="{ row }">
          <img :src="row && row.basic && row.basic.imageList && row.basic.imageList[0] && row.basic.imageList[0].url" class="avatar" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="排序"
        prop="basic.order"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="200px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleDetail(row)">详情</el-button>
          <el-button type="text" class="mr-10" @click="handleEdit(row)">修改</el-button>
          <el-button
            type="text"
            @click="handleDelete(row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
    <detail ref="detail" />
  </div>
</template>

<script>
import moment from 'moment'
import { getPageList, delPage } from '@/api/display'
import Edit from './edit.vue'
import Detail from './detail.vue'
export default {
  name: 'Landing',
  components: { Edit, Detail },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        position: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      if (to.path == '/display/landing') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleDetail(row) {
      this.$refs['detail'].show(row)
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handleDelete(row) {
      this.$baseConfirm(`你确定要删除落地页吗`, null, async () => {
        await delPage({ pageId: row.pageId })
        this.$baseMessage(
          `删除轮播图成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.queryData()
      })
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await getPageList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.avatar {
   height: 64px;
   width: 128px;
   border-radius: 8px;
}
.mr-10 {
  margin-right: 10px;
}
</style>
